import { OrderLineItemResponse, OrderOut } from '../../store/api';
import { shopPrefix } from '../../config';
import { LineItem } from '../../../models/Product';
import { mapOrderProductsToLineItems } from './mapOrderProductsToLineItems';
import { http } from '../axios';

const FETCH_ORDER_URL = `${shopPrefix}/v1/orders/:orderId?`;
const FETCH_ORDER_PRODUCTS_URL = `${shopPrefix}/v1/orders/:orderId/products/:productId?`;

export const fetchOrder = (orderId: string): Promise<OrderOut> => {
    return http
        .get<OrderOut>(FETCH_ORDER_URL, {
            pathParams: { orderId }
        })
        .then(({ data }) => data);
};

export type FetchOrderProductsLineItem = LineItem;

export type FetchOrderProductsResponse = {
    readonly lineItems: ReadonlyArray<FetchOrderProductsLineItem>;
    readonly totalHits: number;
};

type FetchOrderProductsParams = {
    readonly page?: number;
    readonly pageSize?: number;
    readonly sortBy?: string;
};

export const fetchOrderProducts = (
    orderId: string,
    { page, pageSize, sortBy }: FetchOrderProductsParams
): Promise<FetchOrderProductsResponse> => {
    return http
        .get<OrderLineItemResponse>(FETCH_ORDER_PRODUCTS_URL, {
            params: {
                page,
                pageSize,
                sortBy
            },
            pathParams: {
                orderId
            }
        })
        .then(response => {
            const fetchOrderProductsResponse: FetchOrderProductsResponse = {
                lineItems: mapOrderProductsToLineItems(response.data.hits),
                totalHits: response.data.totalHits ?? 0
            };
            return fetchOrderProductsResponse;
        });
};
